<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1> Thane Fide Rapid Chess Tournament 2025</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section-lg">
  <div class="container">
    <div class="sec-title">
      <h2><span>1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament 14 September 2025 Inaugurated.</span></h2>
    </div>

<p>The 1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament 2025 was inaugurated by Shri Lallan Prasad Chaurasia, Ex AICF office bearer and Patron of U.P. Chess Association.</p>

<p>The inauguration ceremony was graced by Shri Salim Sheikh, Superintending Engineer, PWD Mumbai (Guest of Honour), Shri P.B. Bhilare, President Mumbai City Chess Association & Joint Secretary MCA, Dr. D.D. Tandel, Joint Secretary Thane District Chess Association, and Shri Bhushan Shriwas, Organising Secretary.</p>

<p>The program was compered by Shri S.S. Soman, Member, MCA Observer Committee.</p>
  </div>
</section>
<section class="section-lg pt-0">
  <div class="container">
     <hr class="mb-5">
              <div class="sec-title mt-4 text-center">
                    <h2><span>Photo Gallery</span></h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

  </div>
</section>
